import { isLogin } from '@/utils/auth.js';
import NProgress from 'nprogress';
/**
 * 路由定义
 * transitionName: 路由切换过渡动画名称
 */
import { createRouter, createWebHistory } from 'vue-router';
import routerCertified from './routerCertified.js';
import routerCommon from './routerCommon.js';
import routerCommunity from './routerCommunity.js';
import routerCompetition from './routerCompetition.js';
// import routerExpert from './routerExpert.js';
// import routerGrowth from './routerGrowth.js';
import routerHome from './routerHome.js';
// import routerIndustry from './routerIndustry.js';
// import routerOther from './routerOther.js';
import routerMessage from './routerMessage.js';
import routerPay from './routerPay.js';
import routerReward from './routerReward.js';
import routerSchool from './routerSchool.js';
import routerToolbox from './routerToolbox.js';
// import routerTeacherCamp from './routerTeacherCamp.js';
import routerUser from './routerUser.js';

export const allRouter = [
  ...routerHome,
  routerSchool,
  routerCertified,
  // routerTeacherCamp,
  ...routerReward,
  ...routerCompetition,
  ...routerToolbox,
  // routerIndustry,
  // ...routerOther,
  ...routerCommunity,
  // ...routerGrowth,
  // ...routerExpert,
  routerUser,
  routerMessage,
  ...routerPay,
];

const router = createRouter({
  // history: createWebHistory(import.meta.env.BASE_URL),
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home',
    },
    {
      path: '/',
      component: () => import('@/pages/index.vue'),
      children: [
        ...allRouter,

        // 404页面
        {
          path: '/404',
          name: '404',
          meta: {
            title: '404',
            needLogin: false,
            transitionName: 'router',
          },
          component: () => import('@/components/Router404.vue'),
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      meta: {
        title: '登录',
        needLogin: false,
        transitionName: 'router',
      },
      component: () => import('@/pages/module-login/index.vue'),
    },
    ...routerCommon,
    {
      path: '/:pathMatch(.*)',
      redirect: '/404',
    },
  ],
  scrollBehavior() {
    // always scroll to top
    return { top: 0 };
  },
});

router.beforeEach((to, from, next) => {
  NProgress.start();

  // 如果需要登录
  if (to.meta.needLogin) {
    // 如果有token 则直接放行
    if (isLogin()) {
      next();
    } else {
      // 否则去登录页
      next({ path: '/login', query: { redirect: to.fullPath } });
    }
  } else {
    // 不需要登录则直接放行
    next();
  }
});

// 修改标题的工作可以放在全局后置守卫
router.afterEach((to) => {
  NProgress.done();

  if (to.meta.title) {
    if (to.meta.title.includes('首页')) {
      document.title = `3T Club-数智人才培养综合服务平台`;
    } else {
      document.title = `3T Club-${to.meta.title}`;
    }
  }
});

export default router;
